/**
 * 변형 처리 UI 핸들러 클래스
 * Modify/Translate 시 UI 관련 처리를 담당합니다.
 */
export class TransformationUIHandler {
  constructor(getImagePolygonPairs) {
    this.getImagePolygonPairs = getImagePolygonPairs;
  }

  /**
   * Modify 시작 시 UI 초기화
   * @param {Object} feature - OpenLayers Feature
   */
  initializeModifyUI(feature) {
    const imageId = feature.get('imageId');
    const imagePolygonPairs = this.getImagePolygonPairs();
    const imagePolygonPair = imagePolygonPairs[imageId];
    console.log('imagePolygonPair && imagePolygonPair.geoImageLayer)',imagePolygonPair, imagePolygonPair?.geoImageLayer);
    if (imagePolygonPair && imagePolygonPair.geoImageLayer) {
      // 인터랙션 시작 시 이미지 투명도 낮추기
      imagePolygonPair.geoImageLayer.setOpacity(0.5);
      console.log('[TransformationUIHandler] Modify UI 초기화', { imageId, opacity: 0.5 });
    }
  }

  /**
   * Modify 완료 시 UI 정리
   * @param {Object} feature - OpenLayers Feature
   */
  finalizeModifyUI(feature) {
    const imageId = feature.get('imageId');
    const imagePolygonPairs = this.getImagePolygonPairs();
    const imagePolygonPair = imagePolygonPairs[imageId];

    if (imagePolygonPair && imagePolygonPair.geoImageLayer) {
      // 인터랙션 완료 시 이미지 투명도 복원
      imagePolygonPair.geoImageLayer.setOpacity(imagePolygonPair.options.opacity);
      console.log('[TransformationUIHandler] Modify UI 완료', { imageId, opacity: imagePolygonPair.options.opacity });
    }
  }

  /**
   * Translate 시작 시 UI 초기화
   * @param {Object} feature - OpenLayers Feature
   */
  initializeTranslateUI(feature) {
    const imageId = feature.get('imageId');
    const imagePolygonPairs = this.getImagePolygonPairs();
    const imagePolygonPair = imagePolygonPairs[imageId];

    if (imagePolygonPair && imagePolygonPair.geoImageLayer) {
      // 인터랙션 시작 시 이미지 투명도 낮추기
      imagePolygonPair.geoImageLayer.setOpacity(0.5);
      console.log('[TransformationUIHandler] Translate UI 초기화', { imageId, opacity: 0.5 });
    }
  }

  /**
   * Translate 완료 시 UI 정리
   * @param {Object} feature - OpenLayers Feature
   */
  finalizeTranslateUI(feature) {
    const imageId = feature.get('imageId');
    const imagePolygonPairs = this.getImagePolygonPairs();
    const imagePolygonPair = imagePolygonPairs[imageId];
    //const imagePolygonPair = this.getImagePolygonPairs[imageId];
    if (imagePolygonPair && imagePolygonPair.geoImageLayer) {
      // 인터랙션 완료 시 이미지 투명도 복원
      imagePolygonPair.geoImageLayer.setOpacity(imagePolygonPair.options.opacity);
      console.log('[TransformationUIHandler] Translate UI 완료', { imageId, opacity: imagePolygonPair.options.opacity });
    }
  }
}
